export const AGENT_TABLE_TEST_IDS = {
  wrapper: 'agent-table-wrapper',
  downloadButton: 'agent-table-download-button',
  table: 'agent-table',
} as const;
